import { render } from "./NavMenuItem.vue?vue&type=template&id=7f2092b2&scoped=true"
import script from "./NavMenuItem.vue?vue&type=script&lang=js"
export * from "./NavMenuItem.vue?vue&type=script&lang=js"

import "./NavMenuItem.vue?vue&type=style&index=0&id=7f2092b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2092b2"]])

export default __exports__